import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';

import FormaPago from './ViewModal/FormaPago';
import dialog from "../../../common/utility/dialog";
import HistorialPago from './PrintModal/HistorialPago';


const InputGroup = Input.Group;
const { TabPane } = Tabs;

 class ViewPago extends React.Component {

    
  constructor(props) {
    super(props);
}


handleOk = (e) => {

    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (!err) {
  
        const data = this.fetchReferencias(values);


        const validFormLogic = this.validateFormLogic(data, values);
        if (!validFormLogic) {
          return;
        }

        this.props.onSave(data, this.props.form);
      }
    });
  };


  
  validateFormLogic = (data, values) => {


    var cantidadPago=data.length;
    
    if (cantidadPago===0) {
        dialog.warning(
          "Tiene que agregar los pagos"
        );
        return false;
      }
     
      
    var totalCuotas = parseFloat(
      data.reduce((a, b) => a + (b["total"] || 0), 0)
    );
    
 
      if (totalCuotas !== parseFloat(this.props.formValues.Monto).toFixed(2)) {
        dialog.warning(
          "El monto total de cuotas, debe ser igual al total del pago."
        );
        return false;
      }
     
    

    return true;
  };




  fetchReferencias = (values) => {
    var result = [];

    var keys = [];
    var obj = Object.assign({}, values.arrMetodoPago);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        idCuentasCobrar :this.props.formValues.idDocumentoElctronico,
        idCuentasCobrarDetalle :this.props.formValues.idCuentasCobrarDetalle,
        fecha: values.arrFecha[key].format("DD/MM/YYYY"),
        idMetodoPago: values.arrMetodoPago[key].key,
        idCuenta: values.arridDestino[key]==undefined ? 0 :values.arridDestino[key].key,
        referencia: values.arrreferencia[key],
        total: parseFloat(values.arrMontoCuota[key]),
      });
    });


    return result;
  };


    render() {

        
      const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
 
    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });

  

        return (
            <Modal
                title={"Detalle de Abono"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1100}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cerrar
                    </Button>,  
                                  <Button
                                  key="2"
                                  type="primary"
                                  hidden={true}
                                  onClick={this.handleOk}
                              >
                                  Agregar
                              </Button>
                ]}
            >
                <Form>

                    
                <div className="row">
                        <div className="col-md-4">
                            <Form.Item label="Documento">
                            <Input readOnly
                                    value={this.props.formValues.DocumentoCliente}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-8">
                            <Form.Item label="Cliente">
                                <Input readOnly
                                    value={this.props.formValues.RazonSocialClientemento}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                
                    <div className="col-md-2">
                            <Form.Item label="Cuota">
                                <Input readOnly
                                    value={this.props.formValues.nroCouta}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-2">
                            <Form.Item label="Fecha Pago">
                                <Input readOnly
                                        value={this.props.formValues.Fecha}
                                        suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}

                                        />
                            </Form.Item>


                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Moneda">
                                <Input readOnly
                                    value={this.props.formValues.Moneda}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-3">
                            <Form.Item label="Monto Cuotas">
                                <Input readOnly
                                    value={this.props.formValues.Monto.toFixed(2)}
                                />
                            </Form.Item>
                        </div>

                    </div>
        
             
                    <div className="row">
                        <div className="col-md-12 form-group">

                            <Tabs
                             
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="plus"
                                            type="primary"
                                            hidden={true}
                                            onClick={() =>
                                                this.props.onAgregarDetalle(
                                                    this.props.form.setFieldsValue,
                                                    this.props.form.getFieldValue
                                                )
                                            }
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                    }
                            >

                                <TabPane tab="Historial de Pagos" key="1">
                             {/*        <FormaPago
                                        dataSource={this.props.formValues.listaFormaPago}
                                        onRemove={this.props.onRemoverFormaPago}
                                        listaMetodoPago={this.props.formValues.listaMetodoPago}
                                        listaCuentaDestino={this.props.formValues.listaCuentaDestino}
                                        onGetFieldDecorator={getFieldDecorator}
                                    /> */}

                                    <HistorialPago
                                        dataSource={this.props.formValues.lst_historialPago}
                                    />
                                </TabPane>


                        </Tabs>  
                        </div>
                    </div>
          
                </Form>
            </Modal>
        );
    }
}

export default Form.create()(ViewPago);
